import { ColumnDef, ColumnHelper } from '@tanstack/react-table'

import { commonAccessorColumn, dateAccessorColumn, moneyAccessorColumn } from '@/components/table'
import { B2CPaymentsRequest } from '@/@types/b2c.types.ts'
import { B2CStateRenderer } from '@/pages/b2c/components/b2c-state-renderer.tsx'

export const KEY_PAGE = 'b2с-payments'

type VisibleColumns =
  | 'transferId'
  | 'registryId'
  | 'reference'
  | 'amount'
  | 'commissionMerchant'
  | 'writeOffAmount'
  | 'recPam'
  | 'recPhone'
  | 'rcvBankNameRus'
  | 'state'
  | 'updateTime'
  | 'statusComment'

export type PartialPaymentsRequest = Pick<B2CPaymentsRequest, VisibleColumns>

export const defaultSettings: Record<keyof PartialPaymentsRequest, string> = {
  transferId: '№ операции',
  registryId: '№ реестра',
  reference: '№ заявки В2С',
  amount: 'Сумма',
  commissionMerchant: 'Комиссия банка',
  writeOffAmount: 'Сумма списания со счёта',
  recPam: 'Ф.И.О. получателя',
  recPhone: 'Номер телефона получателя',
  rcvBankNameRus: 'Банк получателя',
  state: 'Статус перевода',
  updateTime: 'Дата, время',
  statusComment: 'Комментарий к статусу',
}

export function getColumnsSettings(
  columnHelper: ColumnHelper<B2CPaymentsRequest>
): Record<keyof PartialPaymentsRequest, ColumnDef<B2CPaymentsRequest, any>> {
  return {
    transferId: columnHelper.accessor('transferId', commonAccessorColumn('№ операции')),
    registryId: columnHelper.accessor('registryId', commonAccessorColumn('№ реестра')),
    reference: columnHelper.accessor('reference', commonAccessorColumn('№ заявки В2С')),
    amount: columnHelper.accessor('amount', moneyAccessorColumn('Сумма')),
    commissionMerchant: columnHelper.accessor('commissionMerchant', moneyAccessorColumn('Комиссия банка')),
    writeOffAmount: columnHelper.accessor('writeOffAmount', moneyAccessorColumn('Сумма списания со счёта')),
    recPam: columnHelper.accessor('recPam', commonAccessorColumn('Ф.И.О. получателя')),
    recPhone: columnHelper.accessor('recPhone', commonAccessorColumn('Номер телефона получателя')),
    rcvBankNameRus: columnHelper.accessor('rcvBankNameRus', commonAccessorColumn('Банк получателя')),
    state: columnHelper.accessor('state', {
      header: 'Статус перевода',
      cell: (props) => <B2CStateRenderer value={props.getValue()} />,
    }),
    updateTime: columnHelper.accessor('updateTime', dateAccessorColumn('Дата, время', true, 'Europe/Moscow')),
    statusComment: columnHelper.accessor('statusComment', commonAccessorColumn('Комментарий к статусу')),
  }
}
